import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

export default function PendingAccessPage() {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(d => d.length >= 3 ? '' : d + '.');
    }, 600);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-[#FFF8F0] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-amber-50 border border-amber-200 flex items-center justify-center mx-auto mb-6">
          <Clock size={32} className="text-amber-600" />
        </div>

        <div className="flex items-center justify-center gap-2 mb-8">
        <div className="w-14 h-14 shrink-0 flex items-center justify-center">
        <img src="/tempust-logo.png" alt="Tempust" className="w-14 h-14 object-contain" />
        </div>
          <span className="text-[#1F1A17] font-bold text-lg tracking-tight font-outfit">Tempust</span>
        </div>

        <h1 className="text-2xl font-bold text-[#1F1A17] font-outfit mb-3">Access Requested</h1>
        <p className="text-[#6E6258] text-sm leading-relaxed mb-6">
          Your sign-in was successful, but your account is awaiting admin approval.
          You'll be able to access Tempust once an admin reviews your request.
        </p>

        <div className="bg-card border border-border rounded-xl px-6 py-4 mb-8">
          <p className="text-[#2B241F] text-sm">
            Waiting for approval<span className="text-amber-600">{dots}</span>
          </p>
        </div>

        <p className="text-[#9C8E84] text-xs">
          If you believe this is a mistake, contact your administrator directly.
        </p>

        <button
          onClick={() => window.location.href = '/login'}
          className="mt-6 text-xs text-[#9C8E84] hover:text-[#6E6258] transition-colors underline underline-offset-2"
        >
          Back to sign in
        </button>
      </div>
    </div>
  );
}